module.exports = __webpack_public_path__ + "img/10979908_L.55fa81b1.png";